import axiosInstance from "../AxiosInit/AxiosInstance";
import {
  setLoginData,
  setLoading,
  setError,
} from "../components/login/LoginSlice";

import { selectSelectedYearId } from "../Redux/financialYearSlice";


export const loginUser = (credentials) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return new Promise((resolve, reject) => {
      axiosInstance
        .post("/corporate_login", credentials)
        .then((response) => {
          const { data } = response;
          if (response?.status === 200) {
            console.log(data);
            dispatch(setLoginData(data));
            resolve(data);
            dispatch(setError(null));
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          dispatch(setError(data?.message || "An error occurred during login"));
          reject(data?.message || "An error occurred during login");
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    });
  };
};

// Action to fetch escalation data from the API
export const fetchEscalationMatrix = (corporateId) => {
  // Return a thunk function that will be executed by Redux Thunk middleware
  return async (dispatch, getState) => {
    try {
      const state = getState();
      // Get the currently selected financial year ID from the Redux state
      const financialYearId = selectSelectedYearId(state);

      // 1. Validate that both required IDs are present before making an API call
      if (!corporateId || !financialYearId) {
        throw new Error("Corporate ID and Financial Year ID are required to fetch the escalation matrix.");
      }

      // 2. Make the API call with the updated URL structure
      const response = await axiosInstance.get(
        `/get_escalation_matrix_corporate/${corporateId}/${financialYearId}`
      );

      // 3. Check for a successful response and the expected data structure
      if (response?.status === 200 && response?.data?.policy_escalation_matrix) {

        const originalMatrix = response.data.policy_escalation_matrix;
        const cleanedMatrix = {};

        // 4. Data Cleaning: Iterate to ensure we only store valid, non-empty data
        // Iterate over each policy type (e.g., "GMC")
        for (const policyType in originalMatrix) {
          if (Object.hasOwnProperty.call(originalMatrix, policyType)) {
            const policiesByNumber = originalMatrix[policyType];
            const validPolicies = {};

            // Iterate over each policy number for the current policy type
            for (const policyNumber in policiesByNumber) {
              if (Object.hasOwnProperty.call(policiesByNumber, policyNumber)) {
                const contacts = policiesByNumber[policyNumber];
                // Filter out policies that have an empty or null list of contacts
                if (Array.isArray(contacts) && contacts.length > 0) {
                  // Use a fallback key for null policy numbers
                  const policyKey = policyNumber === 'null' || !policyNumber ? 'N/A' : policyNumber;
                  validPolicies[policyKey] = contacts;
                }
              }
            }

            // Only add the policy type to our result if it has at least one valid policy with contacts
            if (Object.keys(validPolicies).length > 0) {
              cleanedMatrix[policyType] = validPolicies;
            }
          }
        }

        // Return the original structure but with the cleaned list
        return { policy_escalation_matrix: cleanedMatrix };

      } else {
        // Handle cases where the response is 200 but the data is not in the expected format
        throw new Error("Failed to fetch escalation matrix or data format is incorrect.");
      }
    } catch (error) {
      // 5. Robust Error Handling: Extract the specific error message from the API response if it exists
      const data = error?.response?.data;
      const errorMessage = data?.message || error.message || "An error occurred while fetching the escalation matrix.";

      // Log the detailed error for debugging purposes
      console.error("Error fetching escalation matrix:", errorMessage, error);

      // Re-throw the error so the UI layer can catch it and display a message to the user
      throw new Error(errorMessage);
    }
  };
};

export const getPolicyFeature = (id) => {
  // 2. THE THUNK IS ASYNC AND RECEIVES getState
  return async (dispatch, getState) => {
    try {
      // 3. GET THE financialYearId FROM THE REDUX STORE
      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      // Validate that both IDs are available
      if (!id || !financialYearId) {
        throw new Error("Corporate ID and Financial Year ID are required to get policy features.");
      }

      // 4. AWAIT THE API CALL WITH THE UPDATED URL
      const response = await axiosInstance.get(
        `/get_policy_feature_coporate/${id}/${financialYearId}`
      );

      // Handle the success case
      if (response?.status === 200) {
        return response.data; // This will be the resolved value of the promise
      } else {
        // Handle non-200 success statuses
        throw new Error(`Failed to fetch policy features. Status: ${response.status}`);
      }
    } catch (error) {
      // 5. CATCH AND RE-THROW ERRORS FOR THE COMPONENT TO HANDLE
      const errorMessage =
        error?.response?.data?.message || // Message from API
        error.message || // Message from thrown error
        "An error occurred while fetching policy features.";

      console.error("Error in getPolicyFeature:", errorMessage);
      // Re-throwing the error makes the promise reject, so .catch() works in the component
      throw new Error(errorMessage);
    }
  };
};
export const getPolicyFeatureDataCorporate = (policyid, ref_md_department_id) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `/get_policy_feature_data_coporate/${policyid}/${ref_md_department_id}`
      );
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch policy feature data");
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching policy feature data"
      );
    }
  };
};

export const fetchDocumentDetails = (id) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      if (!id || !financialYearId) {
        throw new Error("Corporate ID and Financial Year ID are required to fetch documents.");
      }

      const response = await axiosInstance.get(
        `/corporate_get_documents/${id}/${financialYearId}`
      );

      if (response?.status === 200) {
        return response.data;
      } else {
        throw new Error(`Failed to fetch documents. Status: ${response.status}`);
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "An error occurred while fetching document details.";

      console.error("Error in fetchDocumentDetails:", errorMessage);
      throw new Error(errorMessage);
    }
  };
};


export const fetchEnrollmenttype = (corporateId) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/corporate_get_enrollmenttype`, { corporateId });
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch escalation matrix");
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching escalation data"
      );
    }
  };
};

export const fetchEnrollmentDetails = (corporateId) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      // Validate that both required IDs are present
      if (!corporateId || !financialYearId) {
        throw new Error("Corporate ID and Financial Year ID are required.");
      }

      const response = await axiosInstance.get(
        `/corporate_get_enrollmentdetails/${corporateId}/${financialYearId}`
      );

      // Check for a successful response and the expected data structure
      if (response?.status === 200 && response?.data?.policy_enrollment_details) {

        const originalDetails = response.data.policy_enrollment_details;
        const cleanedDetails = {};

        // Iterate over each policy type (e.g., "GMC", "GPA")
        for (const policyType in originalDetails) {
          if (Object.hasOwnProperty.call(originalDetails, policyType)) {
            const policies = originalDetails[policyType];

            // Filter out any policies that have an empty or null policy number
            // Accept policies that have either a valid policy_number OR a policy_id as fallback
            const validPolicies = policies.filter((p) => {
              const policyNumber = p.policy_details?.policy_number?.trim();
              const policyId = p.policy_details?.policy_id;

              // Accept if policy_number is not empty, OR if policy_id exists as fallback
              return (policyNumber && policyNumber !== "") || policyId;
            });

            // Only add the policy type to our result if it has at least one valid policy
            if (validPolicies.length > 0) {
              cleanedDetails[policyType] = validPolicies;
            }
          }
        }

        // Return the original structure but with the cleaned list
        return { policy_enrollment_details: cleanedDetails };

      } else {
        throw new Error("Failed to fetch enrollment details or data format is incorrect.");
      }
    } catch (error) {
      const data = error?.response?.data;
      const errorMessage = data?.message || error.message || "An error occurred while fetching enrollment details.";
      console.error(errorMessage, error);
      throw new Error(errorMessage);
    }
  };
};


export const createEnrollmentDataUpload = (formData) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `/corporate_create_enrollmentdataupload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${formData.get('token')}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Handle successful response (200)
      if (response?.status === 200) {
        return {
          status: true,
          message: response?.data?.message || "Enrollment Data Created Successfully",
          data: response?.data
        };
      }
    } catch (error) {
      // Handle error responses (400, 422, etc.)
      const errorResponse = error?.response;
      const errorData = errorResponse?.data;

      // Extract error message and details
      let errorMessage = "An error occurred while creating enrollment data";
      let errorDetails = null;

      if (errorData) {
        // Get the message from the error response
        errorMessage = errorData?.message || errorMessage;

        // Get error details if available (for validation errors)
        if (errorData?.error) {
          errorDetails = errorData.error;
        }
      }

      // Throw error with proper structure so component can handle it
      throw {
        status: false,
        message: errorMessage,
        error: errorDetails,
        statusCode: errorResponse?.status
      };
    }
  };
};


export const fetchDependentData = (employeeCode) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/corporate_get_dependentdetails/${employeeCode}`);
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch dependent data");
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching dependent data"
      );
    }
  };
};

export const fetchDeletionList = (policyId, page = 1, limit = 10, searchParams = {}) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams({ page, per_page: limit, ...searchParams }).toString();
      const response = await axiosInstance.get(
        `/enrollment_deletion-list_search/${policyId}?${query}`
      );
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch deletion list");
        return null;
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching the deletion list"
      );
      return null;
    }
  };
};

export const fetchAdditionList = (policyId, page = 1, limit = 10, searchParams = {}) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams({ page, per_page: limit, ...searchParams }).toString();
      const response = await axiosInstance.get(
        `/enrollment_addition-list_search/${policyId}?${query}`
      );
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch addition list");
        return null;
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching the addition list"
      );
      return null;
    }
  };
};

export const fetchActiveList = (policyId, page = 1, limit = 10, searchParams = {}) => {
  console.log("policyId----", policyId, page, limit)
  return async (dispatch) => {
    try {
      const query = new URLSearchParams({ page, per_page: limit, ...searchParams }).toString();
      const response = await axiosInstance.get(
        `/enrollment_activelist_search/${policyId}?${query}`
      );
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch active list");
        return null;
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching the active list"
      );
      return null;
    }
  };
};

export const fetchInceptionList = (policyId, page = 1, limit = 10, searchParams = {}) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams({ page, per_page: limit, ...searchParams }).toString();
      const response = await axiosInstance.get(
        `/enrollment_inception-list_search/${policyId}?${query}`
      );
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch inception list");
        return null;
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching the inception list"
      );
      return null;
    }
  };
};


export const fetchEnrollmentList = (corporateId) => {
  // Return an async thunk that has access to dispatch and getState
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      // Validate that both required IDs are present before making the API call
      if (!corporateId || !financialYearId) {
        throw new Error("Corporate ID and Financial Year ID are required.");
      }

      // Append the financialYearId to the API endpoint
      const response = await axiosInstance.get(
        `/corporate_get_enrollmentlist/${corporateId}/${financialYearId}`
      );

      // Check for a successful response and the expected data structure
      if (response?.status === 200 && response?.data?.policy_enrollment_details) {
        const originalDetails = response.data.policy_enrollment_details;
        const cleanedDetails = {};

        // Iterate over each policy type (e.g., "GMC", "Marine") to clean the data
        for (const policyType in originalDetails) {
          if (Object.hasOwnProperty.call(originalDetails, policyType)) {
            const policies = originalDetails[policyType];

            // Include all policies - don't filter by policy_number since we use policy_id as fallback
            const validPolicies = policies.filter(p => {
              const details = p.policy_details;
              // Handle the array structure (like in "Marine")
              if (Array.isArray(details) && details.length > 0) {
                return details[0].policy_id; // Only filter by policy_id, not policy_number
              }
              // Handle the object structure (like in "GMC")
              if (details && typeof details === 'object' && !Array.isArray(details)) {
                return details.policy_id; // Only filter by policy_id, not policy_number
              }
              return false; // Exclude if format is unexpected
            });

            // Only add the policy type to our result if it has at least one valid policy
            if (validPolicies.length > 0) {
              cleanedDetails[policyType] = validPolicies;
            }
          }
        }

        // Return the original response structure but with the cleaned policy list
        return { ...response.data, policy_enrollment_details: cleanedDetails };
      } else {
        // Handle cases where the request succeeds but data is not as expected
        throw new Error("Failed to fetch enrollment list or data format is incorrect.");
      }
    } catch (error) {
      // Improve error handling to extract a specific message from the API response
      const data = error?.response?.data;
      const errorMessage = data?.message || error.message || "An error occurred while fetching the enrollment list.";
      console.error(errorMessage, error);
      // Re-throw a clean error message for the component to catch and display
      throw new Error(errorMessage);
    }
  };
};


export const fetchClaimdetailsList = (corporateId) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      if (!corporateId || !financialYearId) {
        const errorMessage = "Corporate ID and Financial Year ID are required to fetch claim details.";
        throw new Error(errorMessage);
      }
      const response = await axiosInstance.get(
        `/get_claimdetails_list/${corporateId}/${financialYearId}`
      );

      if (response?.status === 200 && response?.data) {
        return response.data;
      } else {
        throw new Error("Failed to fetch claim details list");
      }
    } catch (error) {
      const data = error?.response?.data;
      const errorMessage = data?.message || error.message || "An error occurred while fetching claim details list";

      console.error(errorMessage, error);

      throw new Error(errorMessage);
    }
  };
};

export const fetchCashlesshospitalData = (corporateId) => {
  // 2. THE THUNK IS ASYNC AND RECEIVES getState
  return async (dispatch, getState) => {
    try {
      // 3. GET THE financialYearId FROM THE REDUX STORE
      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      // Validate that both IDs are available before making the request
      if (!corporateId || !financialYearId) {
        throw new Error("Corporate ID and Financial Year ID are required to get hospital data.");
      }

      // 4. AWAIT THE API CALL WITH THE UPDATED URL
      const response = await axiosInstance.get(
        `/get_cashless_hospital/${corporateId}/${financialYearId}`
      );

      // Handle the success case
      if (response?.status === 200) {
        return response.data; // This value is returned to the component's .then()
      } else {
        // Handle non-200 success statuses
        throw new Error(`Failed to fetch cashless hospital data. Status: ${response.status}`);
      }
    } catch (error) {
      // 5. CATCH AND RE-THROW ERRORS FOR THE COMPONENT TO HANDLE
      const errorMessage =
        error?.response?.data?.message || // Message from API response
        error.message || // Message from a manually thrown error
        "An error occurred while fetching cashless hospital data.";

      console.error("Error in fetchCashlesshospitalData:", errorMessage);
      // Re-throwing the error ensures the promise rejects and the component's .catch() is triggered
      throw new Error(errorMessage);
    }
  };
};

// export const getCdStatement = (corporateId, page = 1) => {
//   // Return an async thunk function that receives dispatch and getState
//   return async (dispatch, getState) => {
//     try {
//       // Get the current Redux state
//       const state = getState();
//       // Select the financial year ID from the state using a selector
//       const financialYearId = selectSelectedYearId(state);

//       // Validate that the required IDs are present before making the API call
//       if (!corporateId || !financialYearId) {
//         throw new Error("Corporate ID and Financial Year ID are required to fetch the CD statement.");
//       }

//       // Make the GET request to the correct endpoint with all required parameters
//       const response = await axiosInstance.get(
//         `/corporate_get_cdstatement_deposite/${corporateId}/${financialYearId}?page=${page}`
//       );

//       // Check for a successful response status
//       if (response?.status === 200) {
//         // On success, return the data from the response
//         return response.data;
//       } else {
//         // Throw an error for non-200 responses that didn't cause a catchable exception
//         throw new Error(`Failed to fetch CD statement. Status: ${response.status}`);
//       }
//     } catch (error) {
//       // Create a detailed error message, prioritizing the message from the API response
//       const errorMessage =
//         error?.response?.data?.message || // Specific message from API (e.g., "Finding Some Errors...")
//         error.message ||                 // General error (e.g., network failure)
//         "An error occurred while fetching the CD statement."; // Fallback message

//       // Log the detailed error for debugging purposes
//       console.error("Error in getCdStatement:", errorMessage);
//       // Re-throw the error so the calling component (e.g., in a useEffect hook) can catch it
//       // and update the UI accordingly (e.g., show an error message to the user).
//       throw new Error(errorMessage);
//     }
//   };
// };

export const getCdStatement = (corporateId, page = 1) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      if (!corporateId || !financialYearId) {
        throw new Error("Corporate ID and Financial Year ID are required to fetch the CD statement.");
      }

      // New API path uses query params: policy_number and fy_id
      const endpoint = `/v2/corporate_get_cdstatement_deposite?policy_number=${corporateId}&fy_id=${financialYearId}&page=${page}`;

      const response = await axiosInstance.get(endpoint);

      if (response?.status === 200) {
        const data = response.data;
        // Determine if there is any usable record data in Deposit or Premium
        const depositArray = data?.Deposite_entry?.data ?? [];
        const premiumArray = data?.Premium_entry?.data ?? [];
        const hasUsableData = (Array.isArray(depositArray) && depositArray.length > 0) || (Array.isArray(premiumArray) && premiumArray.length > 0);
        // If there's no usable data but the API returned an explanatory message, surface it as an error
        if (!hasUsableData && data?.message) {
          throw new Error(data.message);
        }
        return data;
      } else {
        throw new Error(`Failed to fetch CD statement. Status: ${response.status}`);
      }
    } catch (error) {
      // If the backend responded with data (even on non-200 status), prefer returning usable data
      const responseData = error?.response?.data;
      const depositArray = responseData?.Deposite_entry?.data ?? [];
      const premiumArray = responseData?.Premium_entry?.data ?? [];
      const hasUsableData = (Array.isArray(depositArray) && depositArray.length > 0) || (Array.isArray(premiumArray) && premiumArray.length > 0);

      if (hasUsableData) {
        // Return the data object so the UI can render partial results
        return responseData;
      }

      const errorMessage = responseData?.message || error?.message || "An error occurred while fetching the CD statement.";
      console.error("Error in getCdStatement:", errorMessage);
      throw new Error(errorMessage);
    }
  };
};

export const fetchCorporateBufferList = (corporateId) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/get_bufferlist_list/${corporateId}`);
      if (response?.status === 200 && response?.data) {
        return response.data;
      } else {
        throw new Error("Failed to fetch corporate buffer list data");
      }
    } catch (error) {
      console.error("An error occurred while fetching corporate buffer list data", error);
      throw error;
    }
  };
};

export const fetchDependentDetails = (employeeCode, policyId) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/corporate_get_dependentdetails/${employeeCode}/${policyId}`);
      if (response?.status === 200 && response?.data) {
        return response.data;
      } else {
        throw new Error("Failed to fetch dependent details");
      }
    } catch (error) {
      const data = error?.response?.data;
      const errorMessage = data?.message || error.message || "An error occurred while fetching dependent details";
      console.error(errorMessage, error);
      throw new Error(errorMessage);
    }
  };
};


export const fetchEnrollmentPolicyType = (Id) => {
  // The function now returns an async thunk with access to getState
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      // Validate that both required IDs are present before making the API call
      if (!Id || !financialYearId) {
        const errorMessage = "Corporate ID and Financial Year ID are required.";
        // Throw an error to be caught by the catch block
        throw new Error(errorMessage);
      }

      // Append the financialYearId to the API endpoint
      const response = await axiosInstance.get(
        `/corporate_get_policy_type/${Id}/${financialYearId}`
      );

      if (response?.status === 200 && response?.data) {
        return response.data;
      } else {
        // This handles cases where the request succeeds but the data is not as expected
        throw new Error("Failed to fetch policy type data");
      }
    } catch (error) {
      // Improved error handling to extract the message from the response if available
      const data = error?.response?.data;
      const errorMessage = data?.message || error.message || "An error occurred while fetching policy type data";
      console.error(errorMessage, error);
      // Re-throw the refined error message for the component to handle
      throw new Error(errorMessage);
    }
  };
};

export const fetchEnrollmentUploadData = (policyId, page = 1) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(`/corporate_get_enrollmentuploaddata/${policyId}?page=${page}`);
      if (response?.status === 200) {
        return response?.data;
      } else {
        throw new Error("Failed to fetch enrollment upload data");
      }
    } catch (error) {
      console.error("An error occurred while fetching enrollment upload data", error);
      throw error;
    }
  };
};

export const createIntimateClaimIpd = (post) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `/create_intimateclaim_ipd`,
        post
      );
      console.log("response", response);
      const { data } = response;

      if (response?.status === 200) {
        return data;
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "An error occurred";
      console.error("Error creating sum insured:", errorMessage);
      throw new Error(errorMessage);
    }
  };
};
export const createIntimateClaimOpd = (formData) => {

  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `/create_intimateclaim_opd`,
        formData
      );
      console.log("response", response);
      const { data } = response;

      if (response?.status === 200) {
        return data;
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "An error occurred";
      console.error("Error creating sum insured:", errorMessage);
      throw new Error(errorMessage);
    }
  };
};

export const getEmployeeCode = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_employeecode/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "Failed to fetch employee code");
        });
    });
  };
};
export const getPatientName = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_patientname/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "Failed to fetch patient name");
        });
    });
  };
};
export const getInitmateClaimList = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_intimateclaim_list`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "Failed to fetch intimate claim list");
        });
    });
  };
};

export const getAdminDashboardDetails = (corporateid) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      const financialYearId = selectSelectedYearId(state);
      if (!corporateid || !financialYearId) {
        return reject("Corporate ID and Financial Year ID are required.");
      }
      axiosInstance
        .get(`/get_corporate_dashboard/${corporateid}/${financialYearId}`)
        .then((response) => {
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          } else {
            reject("Unexpected response status.");
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          const errorMessage = data?.message || "Failed to fetch dashboard details.";
          reject(errorMessage);
        });
    });
  };
};

export const getCorporateReportAgewiseReport = (id) => {

  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {

      const state = getState();
      const financialYearId = selectSelectedYearId(state);

      if (!id || !financialYearId) {
        const errorMessage = "Corporate ID and Financial Year ID are required.";
        return reject(errorMessage);
      }

      axiosInstance
        .get(`/get_claimreport_agewise/${id}/${financialYearId}`)
        .then((response) => {
          console.log("Age-wise report response:", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          // Improved error handling to match the example
          const data = error?.response?.data;
          const errorMessage = data?.message || "Failed to fetch age-wise report.";
          reject(errorMessage);
        });
    });
  };
};

export const getCorporateMonthwiseReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_monthwisereport/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "Failed to fetch monthwise report");
        });
    });
  };
};


export const getCorporateReportRelationwiseReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_relationwise/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};


export const getCorporateReportSuminsuredwiseReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_suminsuredwise/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getCorporateReportTotalclaimReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_totalcliamreport/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getCorporateReportGenderwiseReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_genderwisereport/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getCorporateDemographyReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_demographyreport/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getTopTenClaimAmountReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_toptencliam_amountreport/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getTopTenPaidClaimAmountReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      // Basic validation to prevent unnecessary API calls with no ID
      if (!id) {
        return reject("A Policy ID is required to fetch the report.");
      }

      axiosInstance
        .get(`/get_claimreport_toptenpaidcliam_amountreport/${id}`)
        .then((response) => {
          const { data } = response;
          // The API returns the array of data directly on success
          if (response?.status === 200) {
            resolve(data);
          } else {
            // This case handles unexpected success status codes
            reject("Received an unexpected response from the server.");
          }
        })
        .catch((error) => {
          // Extract the specific error message from the API response, with fallbacks
          const errorMessage =
            error?.response?.data?.message ||
            error.message ||
            "Failed to fetch top ten paid claims report.";
          reject(errorMessage);
        });
    });
  };
};

export const getEndorsementAnalysisReport = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_Endorsementanalysis/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getClaimDetailsEmployeeData = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimdetails_list_viewdata/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};




export const getClaimReportPaidVsOutstanding = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimreport_paidvsoutstandingwise/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};





export const getAllEmployeeActivity = (corporateId, page = 1) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      // Get the financial year ID from the Redux store
      const financialYearId = selectSelectedYearId(state);

      // Validate that all required IDs are present
      if (!corporateId || !financialYearId) {
        throw new Error("Corporate ID and Financial Year ID are required.");
      }

      // Construct the URL with corporateId, financialYearId, and the page number
      const response = await axiosInstance.get(
        `/get_corporate_employeeactivity/${corporateId}/${financialYearId}?page=${page}`
      );

      // Check for a successful response and the expected data structure
      if (response?.status === 200 && response?.data?.Employee_activity) {
        // Return the entire pagination object
        return response.data.Employee_activity;
      } else {
        throw new Error("Failed to fetch employee activity or data format is incorrect.");
      }
    } catch (error) {
      const data = error?.response?.data;
      const errorMessage = data?.message || error.message || "An error occurred while fetching employee activity.";
      console.error(errorMessage, error);
      // Re-throw the error so the component can handle it
      throw new Error(errorMessage);
    }
  };
};

export const getEndorsementCalculationPolicyDetails = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_endorsementcalculation_policy_details`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data.Employee_activity);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getEndorCalcPolicyType = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_endorsementcalculation_policy_type/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};
export const getEndorCalcPolicyDetails = (corporateId) => {
  return (dispatch) => {
    // Return the promise directly from axiosInstance
    return axiosInstance
      .get(`/get_corporate_endorsementcalculation_policy_details/${corporateId}`)
      .then((response) => {
        // On success, return the data
        return response.data;
      })
      .catch((error) => {
        // On failure, construct a meaningful error message and reject the promise
        const errorMessage =
          error?.response?.data?.message || "Something went wrong";
        return Promise.reject(errorMessage);
      });
  };
};

export const getEndorCalcRackRateData = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_endorsementcalculation_rackrates_data/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};
export const createEndorseRackRates = (id, post) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(`/create_endorsementcalculation_rackrates/${id}`, post)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getAllCorporateEndorsementCalculations = (corporateId) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `/get_all_corporate_endorsement_calculations_data/${corporateId}`
      );
      if (response?.status === 200) {
        return response?.data;
      } else {
        throw new Error("Failed to fetch endorsement calculations");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "An error occurred while fetching endorsement calculations";
      console.error("Error in getAllCorporateEndorsementCalculations:", errorMessage);
      throw new Error(errorMessage);
    }
  };
};

export const getAllCorpEmployee = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get("/get_allcorporateemployee")
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};
export const getAllCorpEmpActivityLog = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get("/get_allemployeeactivity")
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};


export const getCorporateName = (corporateId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_rackrates_corporate_name/${corporateId}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            const filteredData = data?.corporate_name?.filter(
              (item) => item.corporate_name.trim() !== ""
            );
            const corporateDetails = filteredData.map((item) => ({
              corporate_id: item.corporate_id,
              corporate_name: item.corporate_name,
            }));
            resolve(corporateDetails);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getPolicyNumber = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_policy_no/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getCorporateDetails = (id) => {
  return (dispatch) => {
    // dispatch(setLoading(true));
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/corporate_details/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            // dispatch(setLoginData(data));
            resolve(data);
            // dispatch(setError(null));
          }
        })
        .catch((error) => {
          const { data } = error?.response;
          // dispatch(setError(data?.message));
          reject(data?.message);
        });
    });
  };
};

// This action is replaced by getCorporateDashboardDetails
// export const getAdminDashboardDetails = ... (deprecated)


export const getCorporateDashboardDetails = (policyId, financialYearId, policyTypeId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      const token = state?.cauth?.user?.access_token;

      if (!policyId || !financialYearId || policyTypeId === undefined || policyTypeId === null) {
        return reject("Policy ID, Financial Year ID and Policy Type ID are required.");
      }

      axiosInstance
        .get(`/v2/get_corporate_dashboard/${policyId}/${financialYearId}/${policyTypeId}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        })
        .then((response) => {
          if (response?.status === 200) {
            resolve(response.data);
          } else {
            reject("Unexpected response status.");
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          const errorMessage = data?.message || "Failed to fetch corporate dashboard details.";
          reject(errorMessage);
        });
    });
  };
};


export const getsummaryhospitaldata = (id) => {
  return (dispatch) => {
    // dispatch(setLoading(true));
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_summary_hospitalwisedata/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            // dispatch(setLoginData(data));
            resolve(data);
            // dispatch(setError(null));
          }
        })
        .catch((error) => {
          const { data } = error?.response;
          // dispatch(setError(data?.message));
          reject(data?.message);
        });
    });
  };
};


export const fetchClaimDetails = (policyId, page) => {
  console.log("policyId----", policyId, page)
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `/get_claimdetails_list_data/${policyId}?page=${page}`
      );
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch active list");
        return null;
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching the active list"
      );
      return null;
    }
  };
};

export const fetchEnrollmentDetailsData = (policyId, page, limit = 10, searchParams = {}) => {
  console.log("policyId----", policyId, page, limit)
  return async (dispatch) => {
    try {
      const queryParams = new URLSearchParams({ page, limit, ...searchParams }).toString();
      const response = await axiosInstance.get(
        `/corporate_enrollmentdata_search/${policyId}?${queryParams}`
      );
      if (response?.status === 200) {
        return response?.data;
      } else {
        console.error("Failed to fetch enrollment details data");
        return null;
      }
    } catch (error) {
      console.error(
        error?.message || "An error occurred while fetching the enrollment "
      );
      return null;
    }
  };
};

export const getenrollmentsummarydata = (id) => {
  return (dispatch) => {
    // dispatch(setLoading(true));
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_summary_enrollmentsummarydata/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            // dispatch(setLoginData(data));
            resolve(data);
            // dispatch(setError(null));
          }
        })
        .catch((error) => {
          const { data } = error?.response;
          // dispatch(setError(data?.message));
          reject(data?.message);
        });
    });
  };
};



export const getupdateprofiledata = (id) => {
  return (dispatch) => {
    // dispatch(setLoading(true));
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/v2/get_profile/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            // dispatch(setLoginData(data));
            resolve(data);
            // dispatch(setError(null));
          }
        })
        .catch((error) => {
          const { data } = error?.response;
          // dispatch(setError(data?.message));
          reject(data?.message);
        });
    });
  };
};

export const updateProfile = (userId, profileData, token) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.put(
        `/v2/update_profile/${userId}`,
        profileData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.data.message || "Profile update failed");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      throw error;
    }
  };
};

export const getSummaryPolicyData = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_summary_policydata/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getSummaryRelationBandWiseData = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_summary_relationbandwisedata/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getSampleDocument = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_sample_document/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getEnrollmentSampleDocument = (insurerId, policyTypeId, enrollmentTypeId) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `/get_enrollment_sample_document/${insurerId}/${policyTypeId}/${enrollmentTypeId}`
      );

      if (response?.status === 200 && response?.data?.document) {
        return response.data;
      } else {
        throw new Error("Sample document not found");
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch sample document";

      // Preserve the status code by attaching it to the error
      const enhancedError = new Error(errorMessage);
      enhancedError.status = error?.response?.status;
      enhancedError.response = error?.response;

      console.error("Error fetching enrollment sample document:", {
        message: errorMessage,
        status: error?.response?.status
      });

      throw enhancedError;
    }
  };
};

export const getEcardDocument = (id, policyId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/v2/get_ecards/${id}/${policyId}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getEnrollmentDocumentData = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/corporate_get_enrollmentuploaddocument/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const get_claimdetails_list_export = (policy_id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_claimdetails_list_export/${policy_id}`)
        .then((response) => {
          console.log("response", response);
          if (response?.status === 200) {
            resolve(response);
          } else {
            reject("Failed to export claim details");
          }
        })
        .catch((error) => {
          const { data } = error?.response;
          reject(data?.message || "An error occurred while exporting claim details");
        });
    });
  };
}

export const getNotificationData = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/v2/getcorporatenotification/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const updateNotificationData = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .put(`/v2/updatecorporatenotification/${id}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
};

export const getLocationDetail = (pincode) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/get_location_details_for_pincode/${pincode}`)
        .then((response) => {
          console.log("response", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          reject(data?.message || "An error occurred");
        });
    });
  };
}

export const fetchFullListForExport = (policyId, listType) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      if (!policyId || !listType) {
        return reject("Policy ID and List Type are required for export.");
      }

      let endpoint = '';
      switch (listType) {
        case 'active':
          endpoint = `/get_enrollmentlist_activelist_export/${policyId}`;
          break;
        case 'addition':
          endpoint = `/get_enrollmentlist_additionlist_export/${policyId}`;
          break;
        case 'deletion':
          endpoint = `/get_enrollmentlist_deletionlist_export/${policyId}`;
          break;
        case 'inception':
          endpoint = `/get_enrollmentlist_inceptionlist_export/${policyId}`;
          break;
        default:
          return reject("Invalid list type provided for export.");
      }

      axiosInstance
        .get(endpoint)
        .then((response) => {
          console.log(`Export Response for ${listType}:`, response);
          const { data } = response;
          // The API now returns a download link. We must extract and resolve it.
          if (response?.status === 200 && data?.download_link) {
            resolve(data.download_link); // Resolve the promise with the URL.
          } else {
            // If the link is missing, reject the promise.
            reject(`Failed to get a download link for the ${listType} list.`);
          }
        })
        .catch((error) => {
          console.error(`Error fetching export link for ${listType}:`, error.response || error);
          const errorMessage = error?.response?.data?.message || "An unexpected error occurred while preparing the export file.";
          reject(errorMessage);
        });
    });
  };
};

export const corporateEnrollmentDetailsExport = (policyId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      if (!policyId) {
        return reject("Policy ID is required to export enrollment details.");
      }

      const endpoint = `/corporate_enrollmentdetails_export/${policyId}`;

      axiosInstance
        .get(endpoint)
        .then((response) => {
          console.log(`Corporate Enrollment Details Export Response:`, response);
          const { data } = response;
          if (response?.status === 200 && data?.download_link) {
            resolve(data.download_link);
          } else {
            reject("Failed to retrieve a valid download link for the enrollment details.");
          }
        })
        .catch((error) => {
          console.error(`Error fetching enrollment details export link:`, error.response || error);
          const errorMessage = error?.response?.data?.message || "An unexpected error occurred while preparing the export file.";
          reject(errorMessage);
        });
    });
  };
};

export const getEnrollmentUploadExport = (policyId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      if (!policyId) {
        return reject("Policy ID is required to export enrollment upload data.");
      }

      const endpoint = `/corporate_get_enrollmentuploadexport/${policyId}`;

      axiosInstance
        .get(endpoint)
        .then((response) => {
          console.log(`Enrollment Upload Export Response:`, response);
          const { data } = response;
          if (response?.status === 200 && data?.download_link) {
            resolve(data.download_link);
          } else {
            reject("Failed to retrieve a valid download link for the enrollment upload data.");
          }
        })
        .catch((error) => {
          console.error(`Error fetching enrollment upload export link:`, error.response || error);
          const errorMessage = error?.response?.data?.message || "An unexpected error occurred while preparing the export file.";
          reject(errorMessage);
        });
    });
  };
};

export const getCorporateFinancialYears = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`/v2/get_corporate_financial_year`)
        .then((response) => {
          console.log("Financial years response:", response);
          const { data } = response;
          if (response?.status === 200) {
            resolve(data);
          }
        })
        .catch((error) => {
          const data = error?.response?.data;
          const errorMessage = data?.message || "Failed to fetch financial years.";
          reject(errorMessage);
        });
    });
  };
};

// Fetch corporate dashboard for all policy types (GMC, GPA, etc.)
// Deprecated: Use getCorporateDashboardDetails instead
export const fetchCorporateDashboardAllPolicies = (corporateId) => {
  return (dispatch) => {
    return Promise.reject("fetchCorporateDashboardAllPolicies is deprecated. Use getCorporateDashboardDetails with individual policy IDs.");
  };
};

// Fetch dashboard data for specific policy types
// Fetch dashboard data for specific policy IDs
export const fetchDashboardByPolicyType = (policyId, policyTypeId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      try {
        const state = getState();
        const financialYearId = selectSelectedYearId(state);

        if (!policyId || !financialYearId || policyTypeId === undefined) {
          return reject("Policy ID, Financial Year ID, and Policy Type ID are required.");
        }

        console.log(`Fetching dashboard for policyId: ${policyId}, policyTypeId: ${policyTypeId}`);

        axiosInstance
          .get(`/v2/get_corporate_dashboard/${policyId}/${financialYearId}/${policyTypeId}`)
          .then((response) => {
            console.log(`Dashboard Response for policyId ${policyId}:`, response);
            if (response?.status === 200) {
              resolve(response.data);
            } else {
              reject("Unexpected response status.");
            }
          })
          .catch((error) => {
            console.error(`Error fetching dashboard for policyId ${policyId}:`, error);
            const data = error?.response?.data;
            const errorMessage = data?.message || `Failed to fetch dashboard for policyId ${policyId}.`;
            reject(errorMessage);
          });
      } catch (error) {
        console.error("Error in fetchDashboardByPolicyType:", error);
        reject(error?.message || "An error occurred while fetching dashboard details.");
      }
    });
  };
};
